<template>
  <div class="wrapper mt-10" style="margin-bottom: 75px !important">
    <div class="wrapper-login-box">
      <SelectType v-if="!type" @selectType="selectType" />
      <div v-else>
        <h2 class="mb-5" style="color: #fcb134">SET CONTACT CENTER</h2>
        <ValidationObserver ref="observer">
          <ValidationProvider
            v-if="type === 'admin'"
            name="เรื่อง (subject)"
            :rules="'required'"
            v-slot="{ errors }"
          >
            <v-select
              :items="subjectOption"
              v-model="formData.subject"
              solo
              label="เรื่อง (subject)"
              name="เรื่อง (subject)"
              :error-messages="errors"
            ></v-select>
          </ValidationProvider>
          <ValidationProvider name="ชื่อ-นามสกุล (Name)" :rules="'required'" v-slot="{ errors }">
            <v-text-field
              name="ชื่อ-นามสกุล (Name)"
              v-model="formData.name"
              solo
              :error-messages="errors"
              label="ชื่อ-นามสกุล (Name)"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="อีเมล (E-mail)" :rules="'required'" v-slot="{ errors }">
            <v-text-field
              name="อีเมล (E-mail)"
              v-model="formData.email"
              solo
              :error-messages="errors"
              label="อีเมล (E-mail)"
            ></v-text-field>
          </ValidationProvider>
          <ValidationProvider name="เบอร์โทรศัพท์ (Mobile)" :rules="'required'" v-slot="{ errors }">
            <v-text-field
              name="เบอร์โทรศัพท์ (Mobile)"
              v-model="formData.phone_number"
              solo
              :error-messages="errors"
              label="เบอร์โทรศัพท์ (Mobile)"
            ></v-text-field>
          </ValidationProvider>
          <v-btn
            class="mt-3"
            @click="summit"
            :loading="loading"
            large
            color="primary"
            style="width: 100%"
            >Start Chat</v-btn
          >
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import demoApi from '@/api/demo'
import { mapGetters } from 'vuex'
import SelectType from '@/components/Demo/SelectType'
import { config } from '@/constants/page.js'

export default {
  components: {
    SelectType
  },
  data() {
    return {
      type: null,
      loading: false,
      formData: {
        subject: null,
        name: null,
        email: null,
        phone_number: null
      },
      subjectOption: [
        'SET Service',
        'ESG Academy',
        'List Company Journey',
        'SETLink Manual',
        'Other Services'
      ]
    }
  },
  computed: {
    ...mapGetters(['setting'])
  },
  methods: {
    selectType(type) {
      console.log(type)
      this.type = type
    },
    async summit() {
      const vm = this
      if (await vm.$refs.observer.validate()) {
        try {
          vm.loading = true
          const response = await demoApi.loginOrRegis({
            page_id: config[vm.$store.state.apiKey].pageid,
            name: vm.formData.name,
            phone_number: vm.formData.phone_number,
            email: vm.formData.email,
            subject: vm.formData.subject
          })
          if (response && response.data && response.data.userid) {
            this.$store.state.id = response.data.userid
            // localStorage.setItem('id', this.$store.state.id)
            if (this.type == 'admin') {
              this.$store.state.getWelcome = false
            }
            await this.chatlog(this.$store.state.id, this.$store.getters.setting.pageid)
            this.$store.state.isJustLogin = true

            this.$store.commit('SET_LOGIN_STATUS', true)
            vm.errorMessage = null
          }
        } catch (error) {
          vm.loading = false
          vm.resetRecaptcha()
          console.error(error)
          if (error.response) {
            vm.errorMessage = error.response.data.message
          }
        } finally {
          vm.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
